import basicController from "servicestack/basic.controller.properties";
import templateUrl from "emun.salesrep/subrep-edit.htm";
import AutoQuery from "servicestack/auto-query/auto-query";
import resolve from "ioc/resolve";
import modals from 'webmodals/modals'
import CustomerPicker from 'emun.customer/picker/customer-picker'
import ServiceBus from "servicestack/service-bus";

class SubRepEditController {
	constructor() {
		const $ctrl = this;
		basicController($ctrl);
	}
	$onInit() {
		const $ctrl = this;
		const id = $ctrl.subrepId;
		console.info("id", id);
		$ctrl.bus = new ServiceBus();
		$ctrl.filters = [
			{ groupBy: "Status", title: "Status" },
			{ date: "CreatedOn", title: "Created Date" },
			{ date: "LastOrderedOn", title: "Last Order Date" },
			{
			  groupBy: "SalesRepName",
			  title: "Sales Rep",
			  maxHeight: 200,
			  collapsed: true,
			},
			//{ groupBy: "City", maxHeight: 200, collapsed: true },
			{ groupBy: "State", maxHeight: 200, collapsed: true },
			{
			  groupBy: "AccountType",
			  title: "Store Type",
			  maxHeight: 200,
			  collapsed: true,
			}
		];

		if (id == "create") {
			$ctrl.subrep = { id: "create" };
			if ($ctrl.$session.isRep()) {
				$ctrl.subrep.parentRep = {
					id: $ctrl.$session.salesRepId
				};
				$ctrl.subrep.parentRepId = $ctrl.$session.salesRepId;
			}
			$ctrl.customers = new AutoQuery({
				url: "QueryRetailersJoin.json",
				criteria: {
					SubRepId: "NONE"
				},
				filters: $ctrl.filters,
				autoLoad: true,
			});
		} else {
			let options = {
				url: "QuerySubReps.json?Id=" + id,
				autoLoad: true,
				append: false,
				pageSize: 24,
				onLoaded: args => {
					$ctrl.subrep = args.first;
					$ctrl.subrep.parentRep = {
						id: $ctrl.subrep.parentRepId
					};
					$ctrl.customers = new AutoQuery({
						url: "QueryRetailersJoin.json",
						criteria: {
							SubRepId: $ctrl.subrep.email
						},
						filters: $ctrl.filters,
						autoLoad: true,
					});
				}
			};
			$ctrl.query = new AutoQuery(options);
		}
	}
	submit(close) {
		const $ctrl = this;
		console.info("$ctrl.subrep", $ctrl.subrep, $ctrl.subrepId);
		const action = `${$ctrl.subrepId == "create" ? "Register" : "Update"
			}User.json`;

		return $ctrl.bus.send(action, {
			autoLogin: false,
			role: "SubRep",
			// userName: $ctrl.subrep.email,
			email: $ctrl.subrep.email,
			confirmEmail: $ctrl.subrep.email,
			salesRepId: $ctrl.subrep.email,
			displayName: $ctrl.subrep.displayName,
			fullName: $ctrl.subrep.displayName,
			parentRepId: $ctrl.subrep.parentRepId,
			permissions: $ctrl.subrepId == "create"? "AllPermissions" : null,
			forceResetPassword: true,
			password: $ctrl.subrepId == "create" ? "temporaryPassword" : null,
			confirmPassword: $ctrl.subrepId == "create" ? "temporaryPassword" : null,
			id: $ctrl.subrepId == "create" ? null : $ctrl.subrepId
		}).then((res) => {
			$ctrl.subrep.id = $ctrl.subrepId = res.data.id;
			$ctrl.customers.criteria.SubRepId = $ctrl.subrep.email;
			if (close) resolve("$state").go("subreps");
		});
	}

	addCustomer() {
		let $ctrl = this;
		$ctrl.customerIds = [];

		return CustomerPicker({
			title: "Select Customers...",
			subTitle: "",
			applyTagsButtonText: false,
			single: false,
			viewSelections: false,
			hideApplyTags: true,
			hideAddNote: true
		}).then((result) => {
			$ctrl.submit().then(function (res) {
				$ctrl.bus.send("AddSubRepRetailers", {
					SubRepId: $ctrl.subrep.email,
					RetailerIds: Object.keys(result).join(",")
				}).then(function (response) {
					$ctrl.customers.load();
				});
			});
		});
	}
	deleteCustomer(customer) {
		const $ctrl = this;
		return modals
			.confirm("Are you sure you want to remove " + customer.companyName, "Remove Customer?")
			.result.then(function () {
				//console.info("delete it");
				$ctrl.bus
					.send("DeleteSubRepRetailer.json", {
						SubRepId: $ctrl.subrep.email,
						RetailerId: customer.id
					})
					.then(function () {
						return $ctrl.customers.load(true);
					})
					.catch(

					);
			});
	}
}

let SubRepEdit = {
	controller: SubRepEditController,
	bindings: {
		subrepId: "@"
	},
	templateUrl($element, $attrs) {
		return $attrs.templateUrl || templateUrl;
	}
};

export default SubRepEdit;
